import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Flex, OutlineButton, PrimaryButton, Text, TextInline } from '@cko/primitives';
import { trackEvent } from '../../../utils';
export const BLOCKED_MODAL_TEST_IDS = {
    cancelButton: 'test-cancel-view-button',
    changeViewButton: 'test-change-view-button',
    wrapper: 'test-blocked-modal-wrapper',
};
const Wrapper = styled(Flex) `
  background-color: var(--control-bg-primary);
  border-radius: var(--border-r-seed);
  box-shadow: var(--control-e-shoe);
  flex-direction: column;
  padding: var(--layout-shoe);
  width: 368px;
`;
export const BlockedModal = ({ analyticsMetadata, closeModal, onChangeViewClick, modalRefs, modalStyles, requiredAccountName, }) => {
    const handleCancelClick = useCallback(() => {
        if (closeModal) {
            closeModal();
        }
        if (analyticsMetadata) {
            trackEvent('Click - blocked segment-agnostic view - modal - cancel button', analyticsMetadata);
        }
    }, [analyticsMetadata, closeModal]);
    useEffect(() => {
        const handleClickOutsideModal = (event) => {
            const hasClickedOutsideOfModal = modalRefs?.modalElement && !modalRefs.modalElement.contains(event.target);
            const hasClickedOnLinkWrapper = (modalRefs?.linkWrapperElement).contains(event.target);
            if (hasClickedOutsideOfModal && !hasClickedOnLinkWrapper) {
                closeModal?.();
            }
        };
        document.addEventListener('mousedown', handleClickOutsideModal);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsideModal);
        };
    }, [closeModal, modalRefs?.linkWrapperElement, modalRefs?.modalElement]);
    return (React.createElement(Wrapper, { "data-testid": BLOCKED_MODAL_TEST_IDS.wrapper, ref: modalRefs?.setModalRef, style: modalStyles },
        React.createElement(Text, { font: "var(--body-xs-medium)", marginBottom: "var(--layout-spoon)" },
            "Switch to ",
            React.createElement(TextInline, { font: "var(--body-xs-emphasis)" }, requiredAccountName),
            " to view this page"),
        React.createElement(Flex, null,
            React.createElement(PrimaryButton, { "data-testid": BLOCKED_MODAL_TEST_IDS.changeViewButton, onClick: onChangeViewClick }, "Switch view"),
            React.createElement(OutlineButton, { "data-testid": BLOCKED_MODAL_TEST_IDS.cancelButton, onClick: handleCancelClick }, "Cancel"))));
};
